import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * @author cathzhang
 * @modify willpanyang
 * @version 1.0.0.0
 * @class milo.ams.CheckIn
 * 签到模块<br/>
 */
import FlowEngine from '../../amsRequest/flowengine';
import ams from '../../common/ams';
import date from '../../common/date';
var defaultOption = {
  /**
     * @cfg {number} iAMSActivityId AMS活动号
     */
  iAMSActivityId: -1,

  /**
     * @cfg {number} iFlowId 流程号
     */
  iFlowId: -1,

  /**
     * @cfg {number} activityId 订阅模块的id号
     */
  activityId: -1,

  /**
     * @cfg {string} type 类型（签到 comit/查询 query） default:query
     */
  type: 'query',

  /**
     * @cfg {function} success 成功事件 type=comit 是指签到成功后的事件 type=query已签到时的事件
     */
  success: null,

  /**
     * @cfg {object} sData 需要传递的额外参数{“key”:”vaule”}
     */
  sData: {},
  fail: null,

  /**
     * @cfg {function} failure 失败事件 type=comit 此方法无用 type=query时指用户未签到时的处理事件
     */
  failure: null,

  /**
     * @cfg {object} calCfg 日历显示的配置对象，更多参数可参考Calendar & SignCalendar 类
     */
  calCfg: {
    specialday: [],
    container: 'cal',
    onCreateDay: function onCreateDay(day, type, y, m, d) {
      day.innerHTML = "<span>".concat(d, "</span>");
    },
    signDateList: []
  },

  /**
     * @cfg {string} css css样式，有特殊样式，请用绝对地址
     */
  css: 'biz.calendar.cal',

  /**
     * @cfg {object} msg 提示语句对象
     */
  msg: {
    systemError: '很抱歉，系统繁忙，请稍后再试',
    hasCheckin: '您今天已签到',
    checkinSuccess: '签到成功',
    checkinFailure: '签到成功'
  },

  /**
     * @cfg {boolean} calShow 日历是否显示
     */
  calShow: null,

  /**
     * @cfg {boolean} sNeedSubmitPopDiv loding层是否显示
     */
  sNeedSubmitPopDiv: true
};

var getConfig = function getConfig(opt) {
  var iActivityId = opt.iActivityId,
      iFlowId = opt.iFlowId,
      flowConfig = opt.flowConfig;
  return ams.amsInit(iActivityId, iFlowId, flowConfig).then(function (_ref) {
    var config = _ref.config,
        flow = _ref.flow;
    var amsActdesc = window["ams_actdesc_".concat(iActivityId)];
    var gameId = amsActdesc.sServiceType;

    var option = _objectSpread(_objectSpread(_objectSpread({}, defaultOption), config), {}, {
      iNeedAreaRole: flow.iNeedAreaRole !== 0,
      iNeedLogin: flow.iNeedLogin !== 0,
      activityId: flow.functions[0].sExtModuleId,
      gameId: gameId
    });

    return option;
  });
};
/**
 * 签到
 * @return {promise}
 */


var checkin = function checkin(opt) {
  return getConfig(opt).then(function (option) {
    var iAMSActivityId = option.iAMSActivityId,
        iFlowId = option.iFlowId,
        sData = option.sData,
        sNeedSubmitPopDiv = option.sNeedSubmitPopDiv,
        gameId = option.gameId,
        msg = option.msg;
    var checkInInfo = window["CheckInInfo_".concat(option.activityId, "_").concat(option.iQueryFlowId)];
    var serverDt = date.getSeverDateTime();
    var now = date.toDateString(serverDt, '-');

    if (checkInInfo && checkInInfo.ret == 0) {
      for (var i = 0; i < checkInInfo.data.length; i++) {
        if (checkInInfo.data[i].Fdate.substr(0, 10) == now) {
          return {
            iRet: 101,
            sMsg: msg.hasCheckin
          };
        }
      }
    }

    return FlowEngine.submit({
      iActivityId: iAMSActivityId,
      iFlowId: iFlowId,
      sServiceType: gameId,
      sData: sData,
      sNeedSubmitPopDiv: sNeedSubmitPopDiv // objCustomMsg: {
      //     '101' : function() {
      //         LoginManager.login();
      //     },
      //     '600' : function() {
      //         alert(msg.hasCheckin);
      //     }
      // }

    }).then(function (retObj) {
      if (retObj.iRet == 0) {
        window["CheckInInfo_".concat(option.activityId)] = retObj; // 缓存签到信息

        return retObj;
      }

      if (retObj.iRet == -2) {
        // LoginManager.login()
        throw retObj;
      } else {
        throw retObj;
      }
    });
  });
};
/**
     * 查询签到信息并展示
     * @return {promise}
     */


var query = function query(opt) {
  return getConfig(opt).then(function (option) {
    var iAMSActivityId = option.iAMSActivityId,
        iFlowId = option.iFlowId,
        sData = option.sData,
        sNeedSubmitPopDiv = option.sNeedSubmitPopDiv,
        gameId = option.gameId;

    var _serverDt = date.getSeverDateTime();

    var _year = sData.iYear || _serverDt.getFullYear();

    var _month = sData.iMonth || _serverDt.getMonth() + 1;

    var month = _year.toString() + (_month.toString().length == 1 ? "0".concat(_month) : _month);

    var submitData = _objectSpread({
      month: month,
      sServiceType: gameId,
      sign_version: '1.0'
    }, sData);

    return FlowEngine.submit({
      iActivityId: iAMSActivityId,
      iFlowId: iFlowId,
      sData: submitData,
      sNeedSubmitPopDiv: sNeedSubmitPopDiv // objCustomFun : {
      //     "101" : function(){
      //         LoginManager.login();
      //     }
      // }

    }).then(function (res) {
      if (res.iRet == 0) {
        window["CheckInInfo_".concat(option.activityId, "_").concat(option.iQueryFlowId)] = res; // 缓存签到信息
      }

      var data = _objectSpread(_objectSpread({}, res), {}, {
        month: _month,
        year: _year
      });

      return data;
    });
  });
};

export default {
  checkin: checkin,
  query: query
};